import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "valueDisplay"]

    connect() {
        this.update()
    }

    update() {
        const rangeInput = this.inputTarget
        const valueDisplay = this.valueDisplayTarget

        let value = rangeInput.value
        const min = +rangeInput.min || 0
        const max = +rangeInput.max || 100
        const unit = this.element.dataset.unit || ''

        const progress = ((value - min) / (max - min)) * 100
        rangeInput.style.setProperty('--range-progress', `${progress}%`)
        if (valueDisplay) {
            valueDisplay.textContent = `${value}${unit}`
        }
    }
}